import apiClient from './client';
import { ApiResponse, Maintenance, PaginatedResponse, PaginationParams, MaintenanceStatus } from '@/types';

export const maintenanceApi = {
  getAll: (params?: PaginationParams & { status?: MaintenanceStatus; clientId?: string }) =>
    apiClient.get<PaginatedResponse<Maintenance>>('/maintenance', { params }),

  getById: (id: string) =>
    apiClient.get<ApiResponse<Maintenance>>(`/maintenance/${id}`),

  create: (data: Partial<Maintenance>) =>
    apiClient.post<ApiResponse<Maintenance>>('/maintenance', data),

  update: (id: string, data: Partial<Maintenance>) =>
    apiClient.put<ApiResponse<Maintenance>>(`/maintenance/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/maintenance/${id}`),

  updateStatus: (id: string, status: MaintenanceStatus) =>
    apiClient.patch<ApiResponse<Maintenance>>(`/maintenance/${id}/status`, { status }),
};
